// authConfig.js - Configuration for authentication services
export const poolData = {
  UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID || 'us-west-2_9nViaModk',
  ClientId: process.env.REACT_APP_COGNITO_APP_CLIENT_ID || 'l4sddmdfvgg6k4i2q6kffdfir',
};

// Session configuration
export const SESSION_CONFIG = {
  // Token refresh settings
  tokenRefreshBuffer: 15 * 60 * 1000, // Refresh token 15 minutes before expiration
  maxSessionDuration: 8 * 60 * 60 * 1000, // 8 hours default session length
  
  // Storage options
  storageType: 'localStorage', // Changed from 'sessionStorage' to ensure persistence
  
  // Session timeout settings
  sessionTimeoutWarning: 5 * 60 * 1000, // Warn user 5 minutes before timeout
  sessionInactivityTimeout: 30 * 60 * 1000, // Log out after 30 minutes of inactivity
  
  // Auto refresh settings
  autoRefreshWhenActive: true, // NEW: Automatically refresh tokens when user is active
  
  // Error handling
  maxRetryAttempts: 3, // Maximum number of retry attempts for network errors
  retryDelayMs: 5000, // Start with 5 seconds (will increase with exponential backoff)
  
  // Debug settings
  debug: false // Set this to true to enable debug logging
};

// Authentication error messages
export const AUTH_ERRORS = {
  network: "Network error. Please check your internet connection.",
  invalidCredentials: "Incorrect username or password.",
  expiredToken: "Your session has expired. Please log in again.",
  invalidToken: "Authentication error. Please log in again.",
  invalidCode: "Invalid verification code.",
  userNotFound: "User not found.",
  userExists: "An account with this email already exists.",
  passwordMismatch: "Passwords do not match.",
  passwordRequirements: "Password must contain at least 8 characters, including uppercase, lowercase, number, and special character.",
  generalError: "An error occurred. Please try again later.",
  configError: "Authentication configuration error. Please contact support.",
  authenticationError: "Authentication failed. Please log in again to access this feature."
};